import { render, staticRenderFns } from "./TeamScoreboard.vue?vue&type=template&id=143c073c&"
import script from "./TeamScoreboard.vue?vue&type=script&lang=js&"
export * from "./TeamScoreboard.vue?vue&type=script&lang=js&"
import style0 from "./TeamScoreboard.vue?vue&type=style&index=0&id=143c073c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports